<!--
  OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
  all the essential functionalities required for any enterprise.
  Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com

  OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
  the GNU General Public License as published by the Free Software Foundation, either
  version 3 of the License, or (at your option) any later version.

  OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
  without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
  See the GNU General Public License for more details.

  You should have received a copy of the GNU General Public License along with OrangeHRM.
  If not, see <https://www.gnu.org/licenses/>.
-->
<template>
  <header class="cal-header">
    <div class="cal-header-left">
      <div class="cal-month-nav">
        <button
          type="button"
          class="cal-nav-btn"
          title="Previous month"
          aria-label="Previous month"
          @click="$emit('prev')"
        >
          <oxd-icon name="chevron-left" />
        </button>

        <span class="cal-month-label"
          >{{ MONTH_NAMES[month - 1] }} {{ year }}</span
        >

        <button
          type="button"
          class="cal-nav-btn"
          title="Next month"
          aria-label="Next month"
          @click="$emit('next')"
        >
          <oxd-icon name="chevron-right" />
        </button>
      </div>
    </div>

    <div v-if="isAdmin" class="cal-header-right">
      <oxd-button
        display-type="ghost"
        label="Import Holidays"
        icon-name="upload"
        @click="$emit('import-holidays')"
      />
      <oxd-button
        display-type="secondary"
        label="Add Holiday"
        icon-name="calendar-plus"
        class="orangehrm-left-space"
        @click="$emit('add-holiday', null)"
      />
      <oxd-button
        display-type="main"
        label="Add Event"
        icon-name="plus"
        class="orangehrm-left-space"
        @click="$emit('add-event', null)"
      />
    </div>
  </header>
</template>

<script>
import {OxdIcon, OxdButton} from '@ohrm/oxd';
import {MONTH_NAMES} from '../utils/calendarUtils';

export default {
  name: 'CalendarHeader',

  components: {
    'oxd-icon': OxdIcon,
    'oxd-button': OxdButton,
  },

  props: {
    year: {type: Number, required: true},
    month: {type: Number, required: true},
    isAdmin: {type: Boolean, default: false},
  },

  emits: ['prev', 'next', 'add-event', 'add-holiday', 'import-holidays'],

  setup() {
    return {MONTH_NAMES};
  },
};
</script>
